import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { useParams } from "react-router-dom";
import TFObject from '../../components/TFObject';

const Gift = ( { aid, uid, meta, gifts, contacts } ) => {
    let params = useParams();
    const [ g, setGift ] = useState( {
        details: {},
        recipients: []
    } );
    // useEffect( () => {
    //     load( { aid: aid, uid: uid, gid: params.gid } );
    //     loadRecips( { aid: aid, uid: uid, gid: params.gid } );
    // }, [ aid, uid, params.gid, load, loadRecips ] );

    useEffect( () => {
        const list = [];
        if ( gifts[params.gid]?.recips?.length ) {
            gifts[params.gid].recips.forEach( r => {
                if ( contacts[r.cid] ) {
                    list.push( { ...contacts[r.cid], ...r } );
                }
            } );
        }
        if ( gifts ) {
            setGift( prev => {
                return {
                    ...prev,
                    details: gifts[params.gid],
                    recipients: list
                }
            } );
        }
    }, [ params.gid, gifts, contacts ] );

    useEffect( () => {
        document.title = `Third Floor - ${g?.details?.name}`;
    }, [ g ] );

    return (
        <TFObject key={params.gid} objType='gift' obj={g} oid={params.gid} objPick={meta.picklist} header={meta.header} details={meta.details} sidebar={meta.sidebar} />
    )
}

const mapProps = ( state ) => ( {
    aid: state.user.aid,
    uid: state.user.email,
    meta: state.user.meta.gift,
    // g: state.gifts.current
    gifts: state.gifts.byId,
    contacts: state.contacts.byId
} );
  
const mapDispatch = ( dispatch ) => ( {
    // load: dispatch.gifts.loadGift,
    // loadRecips: dispatch.gifts.loadGiftRecipients
} );
  
export default connect( mapProps, mapDispatch )( Gift );